// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f1bba736","652":"cc149336","703":"88523314"}[chunkId] + ".chunk.js";
};